// extracted by mini-css-extract-plugin
export default {"AwardedEmployees_main_item":"Awardes_AwardedEmployees_main_item__hQh-T","open":"Awardes_open__BPVDV","award":"Awardes_award__Ic14T"};